export default __webpack_public_path__ + "static/media/faq.e3ed3ed1.png";